import Api from '../api';

const AccountSnapshotAPI = {
  async getById(id) {
    return Api.get(`/account-snapshots/${id}`);
  },
  async createNewSnapshot(data) {
    return Api.post('/account-snapshots/create', { data });
  }
};

export default AccountSnapshotAPI;
